export const deviceTypeCode = [
    { value : "가상머신", key : "VM"}
]

export const virtualMachineCode = [
    { value : "일반", key : "SVC"},
    { value : "관리", key : "MGMT"},
    { value : "컨테이너노드", key : "CONTNODE"}
]

export const deviceStatusCode = [
    { value : "ACTIVE", key : 'ACT'},
    { value : "BUILD", key : 'BLD'},
    { value : "DELETED", key : 'DEL'},
    { value : "ERROR", key : 'ERR'},
    { value : "HARD_REBOOT", key : 'HDRBOOT'},
    { value : "MIGRATING", key : 'MIG'},
    { value : "PASSWORD", key : 'PW'},
    { value : "PAUSED", key : 'PAUSE'},
    { value : "REBOOT", key : 'RBOOT'},
    { value : "REBUILD", key : 'RBLD'},
    { value : "RESCUE", key : 'RCUE'},
    { value : "RESIZE", key : 'RSIZE'},
    { value : "REVERT_RESIZE", key : 'RVRSIZE'},
    { value : "SHELVED", key : 'SHLVD'},
    { value : "SHELVED_OFFLOADED", key : 'SHLVDOFFLD'},
    { value : "SHUTOFF", key : 'SOFF'},
    { value : "SOFT_DELETED", key : 'SFDEL'},
    { value : "SUSPENDED", key : 'SUSP'},
    { value : "UNKNOWN", key : 'UNK'},
    { value : "VERIFY_RESIZE", key : 'VRFYRSIZE'}
]